import querystring from 'querystring'
import { post, get } from '@integec/fetch-task'

const dateFormat = 'YYYY-MM-DD'

export const getMarginAnalysisTrueupData = targetInfo => data =>
  post(targetInfo, 'marginanalysis/trueup')(data)

export const getMarginAnalysisSummaryGroups = targetInfo => date =>
  get(
    targetInfo,
    'marginanalysis/ms-summary-group?date=' + date.format('YYYY-MM-DD')
  )

export const getMarginAnalysisSummaryGroupsData = targetInfo => ({
  to,
  from,
  iso,
}) =>
  get(
    targetInfo,
    `marginanalysis/ms-summary-group-data?${querystring.stringify({
      iso,
      from: from.format(dateFormat),
      to: to.format(dateFormat),
    })}`
  )
